// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.primary-admin-layout {
  min-height: calc(100vh - 100px);
}
.primary-admin-layout:has(.primary-event-edit) .primary-admin-side-panel {
  display: none;
}
.primary-admin-layout .dashboard-sidebar {
  max-width: 400px;
}
.primary-admin-layout .admin-events-list table {
  min-height: calc(100vh - 300px);
}`, "",{"version":3,"sources":["webpack://./src/routes/admin-panel/primary-admin-panel/style.scss"],"names":[],"mappings":"AAAA;EACE,+BAAA;AACF;AACE;EACE,aAAA;AACJ;AAEE;EACE,gBAAA;AAAJ;AAGE;EACE,+BAAA;AADJ","sourcesContent":[".primary-admin-layout {\n  min-height: calc(100vh - 100px);\n\n  &:has( .primary-event-edit) .primary-admin-side-panel {\n    display: none;\n  }\n\n  .dashboard-sidebar {\n    max-width: 400px;\n  }\n\n  .admin-events-list table {\n    min-height: calc(100vh - 300px);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
